import ModalMobile from '@components/modals/ModalMobile';
import { ECookie } from '@settings/features/settingsOverview/features/settingsOverviewCookies/hooks/useCookies/useCookies.enums';
import { APP_LINKS } from '@utils/variables';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { getCookie, setCookie } from 'src/functions/cookies';
import { isTestEnv } from 'src/functions/functions';
import useResponsive from 'src/hooks/contexts/useResponsive';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import { EOverflow, EPosition, ESize, EThemeColor } from 'src/styles/theme/utils/enums';
import { CookieSettings } from '../CookieSettings/CookieSettings';
import { FlexEx, ModalContainerEx } from './CookieSettingsModal.styles';
import { ICookieSettingsModal } from './CookieSettingsModal.type';

const CookieSettingsModal: FC = () => {
	const { isSmallerThanMd } = useResponsive();
	const [isOpen, setIsOpen] = useState(false);
	const router = useRouter();

	useEffect(() => {
		if (router.pathname.startsWith(APP_LINKS.auth.href)) return;

		const openModal =
			(!router.pathname.startsWith(APP_LINKS.settings.href) &&
				!getCookie(ECookie.hasSelectedCookies) &&
				!isTestEnv()) ||
			// in test env we don't want it to bother every other tests so the modal is only opened on the settings page
			(isTestEnv() && router.pathname.startsWith(APP_LINKS.settings.href) && !getCookie(ECookie.hasSelectedCookies));

		setIsOpen(openModal);
	}, [router]);

	const handleClose = () => setIsOpen(false);

	const handleHideCookieBanner = () => {
		setCookie(ECookie.hasSelectedCookies, true, 365);
		handleClose();
	};

	if (isSmallerThanMd) {
		return (
			<ModalMobile
				isOpen={isOpen}
				onClose={handleClose}
				mdPaddingBottom={ESize.l}
				paddingY={ESize['3xl']}
				paddingX={ESize['2xs']}
				zIndex={900}
			>
				<ModalContent onHideCookieBanner={handleHideCookieBanner} />
			</ModalMobile>
		);
	}

	return (
		<ModalContainerEx
			isOpen={isOpen}
			onClose={handleClose}
			paddingX={ESize['2xs']}
			paddingY={ESize.m}
			id='cookie-settings-modal'
			size={ESize.m}
			backgroundColor={EThemeColor.black}
			position={EPosition.bottomLeft}
			height='100%'
		>
			<ModalContent onHideCookieBanner={handleHideCookieBanner} />
		</ModalContainerEx>
	);
};

const ModalContent: FC<ICookieSettingsModal> = ({ onHideCookieBanner }) => {
	return (
		<FlexEx
			height={'100%'}
			maxHeight='90vh'
			mdMaxHeight={ESize.unset}
			horizontal={EFlex.center}
			overflowY={EOverflow.auto}
		>
			<CookieSettings onHideCookieBanner={onHideCookieBanner} />
		</FlexEx>
	);
};

export { CookieSettingsModal };
